import { render, staticRenderFns } from "./SubSliderWindow.vue?vue&type=template&id=607df3e0&scoped=true&"
import script from "./SubSliderWindow.vue?vue&type=script&lang=js&"
export * from "./SubSliderWindow.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SubSliderWindow.vue?vue&type=style&index=0&id=607df3e0&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "607df3e0",
  null
  ,true
)

export default component.exports